import React from "react";
import "../../assets/styles/smu-table.scss";
import DataTable from "react-data-table-component";
import SmuLoading from "../smu-loading/SmuLoading";
import SmuPaginator from "../smu-paginator/SmuPaginator";

const paginationComponentOptions = {
  rowsPerPageText: "Filas por página",
  rangeSeparatorText: "de",
  selectAllRowsItem: true,
  selectAllRowsItemText: "Todos",
};

const SmuTable = ({
  columns,
  data,
  loading,
  className,
  paginationPerPage,
  rowsStyle,
  defaultSortFieldId,
  defaultSortAsc = true,
  fixedHeader = false,
  fixedHeaderScrollHeight = "400px",
}) => {
  const customStyles = {
    rows: {
      style: rowsStyle || {},
    },
  };

  return (
    <div className={`table-responsive smu-table_ ${className || ""}`}>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationComponentOptions={paginationComponentOptions}
        paginationComponent={SmuPaginator}
        paginationPerPage={paginationPerPage || 10}
        progressPending={!!loading}
        progressComponent={<SmuLoading />}
        noDataComponent="Sin datos para mostrar"
        customStyles={customStyles}
        defaultSortFieldId={defaultSortFieldId}
        defaultSortAsc={defaultSortAsc}
        fixedHeader={fixedHeader}
        fixedHeaderScrollHeight={fixedHeader ? fixedHeaderScrollHeight : undefined}
      />
    </div>
  );
};

export default SmuTable;
